<script>
import FullCalendar from '@fullcalendar/vue3'
import '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
//mport 'bootstrap/dist/css/bootstrap.css';
//import '@fortawesome/fontawesome-free/css/all.css';
//import bootstrapPlugin from '@fullcalendar/bootstrap';
// import AppBar from "../appNavigation/AppBar.vue";
// import NavigationDrawer from "../appNavigation/NavigationDrawer.vue";
import moment from "moment-timezone";
import { ref } from 'vue';
import rrulePlugin from '@fullcalendar/rrule';
// import HtmlRender from "@/components/Test/HtmlRender";
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";
import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'
import 'tippy.js/animations/shift-away-subtle.css'
const upcomingEventData = ref([]);
const upcomingEventData1 = ref([]);
const upcomingEventData2 = ref([]);
const eventsTotal = ref([]);
//const alreadyProcessed = ref([]);
const monthDataFetched = ref(new Set());

export default {
  name: "MyCalendar",
  components: {
    FullCalendar,
    // AppBar,
    // NavigationDrawer,
  },
  data: () => ({
    syllabusDialog: false,
    syllabusTestDialog: false,
    testType: "",
    currentTest: {},
    currentTest1: {},
  }),
  async created() {
    this.$store.dispatch("emptyCalenderEvents");
    await this.fetchDataInital();
    recordAnalyticsEvent(AnalyticsEvents.v2CalendarLoaded)
  },
  computed: {
    calendarEvents: {
      get() {
        let cevents = this.$store.state.calendarEvents;
        console.log("get");
        upcomingEventData.value = [];
        upcomingEventData1.value = [];
        upcomingEventData2.value = [];
        this.$store.commit('loading', true);
        
        for (const key in cevents) {
          //console.log("hello")
          //console.log(key)
          //console.log(cevents[key])
          if (key === "activities") {
            console.log("activites")
            cevents[key].forEach((element, index) => {
              const endTimeStamp = element.activityEndTimeStamp === 0 ? null : new Date(element.activityEndTimeStamp);
              if (element.activityType === "Test") {
                if (element.isFullDayActivity === false) {
                  const color = this.getEventColorNonFullDay(new Date(element.activityStartTimeStamp), endTimeStamp);
                  upcomingEventData.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      id: key,
                      meeting_detailsS: this.getDateTimeFromTimeStamp(new Date(element.activityStartTimeStamp)),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(new Date(element.activityEndTimeStamp)),
                      activitytype: element.activityType,
                      description: element.activityDescription,
                      testId: element.TestDetails.testId,
                      collectionIds: element.TestDetails.collectionIds,
                      testName: element.TestDetails.testname,
                      subjects: element.TestDetails.subjects,
                      isPractice: element.TestDetails.isPractice,
                      alreadyInProgress: element.TestDetails.alreadyInProgress,
                      questionsCount: element.TestDetails.question_count,
                      testDurationInMinutes: element.TestDetails.testduration,
                      startTest: new Date(element.TestDetails.start),
                      endTest: element.TestDetails.endTimeStamp === 0 ? 0 : new Date(element.TestDetails.endTimeStamp)
                    },
                    start: new Date(element.activityStartTimeStamp),
                    end: element.activityEndTimeStamp === 0 ? null : new Date(element.activityEndTimeStamp),
                    startStr: new Date(element.activityStartTimeStamp),
                    endStr: endTimeStamp,
                    backgroundColor: color,
                    //displayEventTime: false,
                    borderColor: "white",
                    display: 'block',
                    textColor: "#121212"
                  }
                }
                else {
                  const color = this.getEventColorFullDay(element.activityDate);
                  upcomingEventData.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      meeting_detailsS: this.getDateTimeFromTimeStamp(element.activityDate),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(element.activityDate),
                      id: key,
                      activitytype: element.activityType,
                      description: element.activityDescription,
                      testId: element.TestDetails.testId,
                      testName: element.TestDetails.testname,
                      isPractice: element.TestDetails.isPractice,
                      collectionIds: element.TestDetails.collectionIds,
                      alreadyInProgress: element.TestDetails.alreadyInProgress,
                      subjects: element.TestDetails.subjects,
                      questionsCount: element.TestDetails.question_count,
                      testDurationInMinutes: element.TestDetails.testduration,
                      startTest: new Date(element.TestDetails.start),
                      endTest: element.TestDetails.endTimeStamp === 0 ? 0 : new Date(element.TestDetails.endTimeStamp),
                      fullDayActivity: true
                    },
                    // startStr: new Date(element.activityStartTimeStamp),
                    // endStr: new Date(element.activityEndTimeStamp),
                    date: element.activityDate,
                    type: "success",
                    backgroundColor: color,
                    //displayEventTime: false,
                    borderColor: "white",
                    display: 'block',
                    textColor: "#121212"
                  }
                }
              }
              if (element.activityType !== "Test") {
                const color = this.getEventColorNonFullDay(new Date(element.activityStartTimeStamp), endTimeStamp);

                if (element.isFullDayActivity === false) {
                  upcomingEventData.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      id: key,
                      meeting_detailsS: this.getDateTimeFromTimeStamp(new Date(element.activityStartTimeStamp)),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(new Date(element.activityEndTimeStamp)),
                      activitytype: this.getClassType(element.activityType),
                      description: element.activityDescription,
                      zoomid: element.liveClassDetails.zoomMeetingId,
                      meetingType: element.liveClassDetails.zoomMeetingType,
                      zoomAccount: element.liveClassDetails.zoomAccount,
                    },
                    start: new Date(element.activityStartTimeStamp),
                    end: element.activityEndTimeStamp === 0 ? null : new Date(element.activityEndTimeStamp),
                    startStr: new Date(element.activityStartTimeStamp),
                    endStr: endTimeStamp,
                    type: "success",
                    backgroundColor: color,
                    //displayEventTime: false,
                    borderColor: "white",
                    display: 'block',
                    textColor: "#121212"
                  }
                }
                else {
                  const color = this.getEventColorFullDay(element.activityDate);
                  upcomingEventData.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      meeting_detailsS: this.getDateTimeFromTimeStamp(element.activityDate),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(element.activityDate),
                      id: key,
                      activitytype: this.getClassType(element.activityType),
                      description: element.activityDescription,
                      zoomid: element.liveClassDetails.zoomMeetingId,
                      meetingType: element.liveClassDetails.zoomMeetingType,
                      zoomAccount: element.liveClassDetails.zoomAccount,
                      fullDayActivity: true
                    },
                    date: element.activityDate,
                    // startStr: new Date(element.activityStartTimeStamp),
                    // endStr: new Date(element.activityEndTimeStamp),
                    type: "success",
                    backgroundColor: color,
                    //displayEventTime: false,
                    borderColor: "white",
                    display: 'block',
                    textColor: "#121212"
                  }
                }
              }
            });
          }
          if (key == "recurringActivities") {
            console.log("RRRactivites")
            cevents[key].forEach((element, index) => {
              if (element.activityType === "Test") {
                if (element.frequency === "daily") {
                  console.log("daily")
                  upcomingEventData1.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      id: key,
                      meeting_detailsS: this.getDateTimeFromTimeStamp(element.startDate),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(element.endDate),
                      activitytype: element.activityType,
                      description: element.activityDescription,
                      testId: element.TestDetails.testId,
                      testName: element.TestDetails.testname,
                      isPractice: element.TestDetails.isPractice,
                      alreadyInProgress: element.TestDetails.alreadyInProgress,
                      subjects: element.TestDetails.subjects,
                      questionsCount: element.TestDetails.question_count,
                      testDurationInMinutes: element.TestDetails.testduration,
                      startTest: new Date(element.TestDetails.start * 1000),
                    },
                    startRecur: element.startDate,
                    endRecur: element.endDate,
                    // daysOfWeek: element.daysOfWeek,
                    type: "success",
                  }
                }
                if (element.frequency === "weekly") {
                  upcomingEventData1.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      id: key,
                      meeting_detailsS: this.getDateTimeFromTimeStamp(element.startDate),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(element.endDate),
                      activitytype: element.activityType,
                      description: element.activityDescription,
                      testId: element.TestDetails.testId,
                      testName: element.TestDetails.testname,
                      isPractice: element.TestDetails.isPractice,
                      alreadyInProgress: element.TestDetails.alreadyInProgress,
                      subjects: element.TestDetails.subjects,
                      questionsCount: element.TestDetails.question_count,
                      testDurationInMinutes: element.TestDetails.testduration,
                      startTest: new Date(element.TestDetails.start * 1000),
                    },
                    rrule: {
                      freq: 'weekly',
                      byweekday: element.daysOfWeek,
                      dtstart: element.startDate, // will also accept '20120201T103000'
                      until: element.endDate // will also accept '20120201'
                    },
                    type: "success",
                  }
                }
              }
              if (element.activityType !== "Test") {
                if (element.frequency === "daily") {
                  console.log("daily")
                  upcomingEventData1.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      id: key,
                      meeting_detailsS: this.getDateTimeFromTimeStamp(element.startDate),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(element.endDate),
                      activitytype: element.activityType,
                      description: element.activityDescription,
                      zoomid: element.liveClassDetails.zoomMeetingId,
                      meetingType: element.liveClassDetails.zoomMeetingType,
                      zoomAccount: element.liveClassDetails.zoomAccount,
                    },
                    startRecur: element.startDate,
                    endRecur: element.endDate,
                    // daysOfWeek: element.daysOfWeek,
                    type: "success",
                  }
                }
                if (element.frequency === "weekly") {
                  upcomingEventData1.value[index] = {
                    title: element.activityTitle,
                    extendedProps: {
                      id: key,
                      meeting_detailsS: this.getDateTimeFromTimeStamp(element.startDate),
                      meeting_detailsE: this.getDateTimeFromTimeStamp(element.endDate),
                      activitytype: element.activityType,
                      description: element.activityDescription,
                      zoomid: element.liveClassDetails.zoomMeetingId,
                      meetingType: element.liveClassDetails.zoomMeetingType,
                      zoomAccount: element.liveClassDetails.zoomAccount,
                    },
                    rrule: {
                      freq: 'weekly',
                      byweekday: element.daysOfWeek,
                      dtstart: element.startDate, // will also accept '20120201T103000'
                      until: element.endDate // will also accept '20120201'
                    },
                    type: "success",
                  }
                }
              }
            });
          }
          // console.log("array is: ue",upcomingEventData.value)
          // console.log("array is: ue1",upcomingEventData1.value)
        }
        // console.log("array is: ue",upcomingEventData.value)
        // console.log("array is: ue1",upcomingEventData1.value)
        // upcomingEventData.value.push(...upcomingEventData1.value); 
        // Array.prototype.push.apply(upcomingEventData.value,upcomingEventData1.value); 

        upcomingEventData2.value = upcomingEventData.value.concat(upcomingEventData1.value);
        eventsTotal.value = eventsTotal.value.concat(upcomingEventData2.value);
        this.$store.commit('loading', false)
        //console.log("array is: total array", upcomingEventData2.value)
        //console.log(upcomingEventData.value, upcomingEventData1.value, upcomingEventData2.value, eventsTotal.value);
        return eventsTotal.value;
      },
    },
    calendarOptions: function () {
      var self = this;
      return {
        plugins: [rrulePlugin, dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          meridiem: 'short',
          hour12: true
        },
        initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prev,next today refresh',
          center: 'title',
          right: 'dayGridMonth timeGridWeek timeGridDay listDay',
        },
        customButtons: {
          prev: {
            text: 'Prev',
            click: () => {
              this.handlePrevNextClick({ ButtonType: "Prev" });
            }
          },
          next: {
            text: 'Next',
            click: () => {
              this.handlePrevNextClick({ ButtonType: "Next" });
            }
          },
          dayGridMonth: {
            text: 'month',
            click: () => {
              this.handleViewClick({ ButtonType: "month" });
            }
          },
          timeGridWeek: {
            text: 'week',
            click: () => {
              this.handleViewClick({ ButtonType: "week" });
            }
          },
          timeGridDay: {
            text: 'day',
            click: () => {
              this.handleViewClick({ ButtonType: "day" });
            }
          },
          listDay: {
            text: 'list',
            click: () => {
              this.handleViewClick({ ButtonType: "list" });
              //console.log(this.$refs.calendarRef);
              //this.$refs.calendarRef.calendar.el.getElementsByClassName("fc-list-event-time");
              //this.injectTimmingsInListViewForWholeDayEvent();
            }
          },
          today: {
            text: 'today',
            click: () => {
              this.switchCalendarViewToToday();
            }
          },
          refresh: {
            //content: 'refresh',
            text: 'refresh',
            click: () => {
              this.refreshCalendarEvents();
            }
          }
        },
        firstDay: 1,
        height: 1100,
        //contentHeight: "auto",//no scroolbar
        //aspectRatio: 1.8,
        allDayText: 'All day',
        scrollTime: '09:00:00',//only works if there is scrollbar
        dialog: false,
        weekends: true,
        selectable: true,
        timeGridMes: {
          type: 'timeGridDay',
          titleFormat: { year: 'numeric', month: 'short' }
        },
        dayMaxEventRows: 3, // for all non-TimeGrid views
        eventClick: function (args) {
          //console.log(args.event);
          recordAnalyticsEvent(AnalyticsEvents.v2CalendarEventPressed, { eventType: args.event.extendedProps.activitytype, eventTitle: args.event.title });
          self.viewTestSyllabus(args.event);
        },
        eventDidMount: function (info) {
          tippy(info.el, {
            content() {
              function convertDateFormat(dateStr) {
                // Parse the input date string
                //console.log("in date str : ", dateStr)
                if (dateStr === null)
                  return "---";

                const dateObj = new Date(dateStr);
                // Get the day, month, and year
                const day = dateObj.toString().split(' ')[0];
                const month = dateObj.toString().split(' ')[1];
                const date = dateObj.getDate();
                const year = dateObj.getFullYear();
                // Get the hours and minutes
                let hours = dateObj.getHours();
                const minutes = dateObj.getMinutes();
                // Convert hours to 12-hour format
                let timeSuffix = 'AM';
                if (hours >= 12) {
                  timeSuffix = 'PM';
                  if (hours > 12) {
                    hours -= 12;
                  }
                }
                // Format minutes to have leading zeros if necessary
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                // Combine the date and time components
                const formattedDate = `${day} ${month} ${date} ${year} ${hours}:${formattedMinutes}${timeSuffix}`;
                return formattedDate;
              }
              //console.log("end str: ", info.event.extendedProps);
              const title = info.event.title;
              const start = convertDateFormat(info.event.extendedProps.startStr);
              const end = convertDateFormat(info.event.extendedProps.endStr);
              //console.log("fullday", info.event.extendedProps.fullDayActivity)
              const visibilityDate = info.event.extendedProps.fullDayActivity === true ? "none" : "block";
              const visiblityFullDay = info.event.extendedProps.fullDayActivity === true ? "block" : "none"
              const color = info.event.backgroundColor;
              //console.log(color);
              return `<div class="tooltip-calendar-container">
                        <div style="background-color:${color};"  class="tooltip-calendar-top">
                          <div class="tooltip-calendar-title" >${title}</div>
                        </div>
                        <div style="display:${visibilityDate};" class="tooltip-calendar-bottom">
                          <div>Start Date: <span class="tooltip-calendar-timming">${start}</span></div>
                          <div>End Date: <span class="tooltip-calendar-timming">${end}</span></div>
                        </div>
                        <div style="display:${visiblityFullDay};text-align:center;" class="tooltip-calendar-bottom">
                          <div>This is a Full Day Activity</div>  
                        </div>
                      </div>`;
            },
            animation: 'shift-away-subtle',
            theme: 'light',
            followCursor: true,
            plugins: [followCursor],
            zIndex: 99999,
            allowHTML: true,
            maxWidth: 350,
          });
        },
        events: eventsTotal.value,
        // eventDidMount: function(info) {
        //    console.log(info.event.extendedProps);
        // },
      }
    },
  },
  beforeUnmount() {
    // eventsTotal.value = [];
    // monthDataFetched.value = new Set();
    // console.log(eventsTotal.value, monthDataFetched.value);
    eventsTotal.value = [];
    monthDataFetched.value = new Set();
    this.$store.dispatch("emptyCalenderEvents");
    console.log("unmounted calander");
    // Perform cleanup tasks here, such as removing event listeners or clearing intervals/timeouts
    // This hook is triggered before the component is destroyed and unmounted from the DOM.
  },
  methods: {
    refreshCalendarEvents() {
      recordAnalyticsEvent(AnalyticsEvents.v2CalendarRefreshButtonPressed)
      this.$refs.calendarRef.calendar.today();
      this.$refs.calendarRef.calendar.changeView('dayGridMonth');
      eventsTotal.value = [];
      monthDataFetched.value = new Set();
      this.$store.dispatch("emptyCalenderEvents");
      this.fetchDataInital();
    },
    switchCalendarViewToToday() {
      recordAnalyticsEvent(AnalyticsEvents.v2CalendarTodayButtonPressed)
      this.$refs.calendarRef.calendar.today();
    },
    async fetchDataInital() {
      const currentDate = new Date();

      // Extract the current month and year
      const month = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1 to get the actual month
      const year = currentDate.getFullYear();

      // Create a unique representation of the current month
      let uniqueMonth = `${year}-${month.toString().padStart(2, '0')}`;
      console.log("first in prev", uniqueMonth);
      if (!monthDataFetched.value.has(uniqueMonth)) {
        const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
        monthDataFetched.value.add(uniqueMonth);
        await this.getData(query);
      }
      uniqueMonth = this.decrementUniqueMonth(uniqueMonth);
      console.log("second in prev", uniqueMonth);
      if (!monthDataFetched.value.has(uniqueMonth)) {
        const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
        monthDataFetched.value.add(uniqueMonth);
        await this.getData(query);
      }
      uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
      console.log("third in prev", uniqueMonth);
      if (!monthDataFetched.value.has(uniqueMonth)) {
        const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
        monthDataFetched.value.add(uniqueMonth);
        await this.getData(query);
      }
    },
    // async fetchData(query) {
    //   const millisecondsInDay = 24 * 60 * 60 * 1000;
    //   console.log("query", query)
    //   if (query.rangeUnit === "month") {
    //     const reqData = {
    //       userId: this.$store.state.userState.userId,
    //       searchQueryFilterAfter: new Date(query.range.start).getTime() - 2 * millisecondsInDay,
    //       searchQueryFilterBefore: new Date(query.range.end).getTime() + millisecondsInDay
    //     };
    //     console.log("reqdata", reqData);
    //     this.$store.commit("calendarEventsLoadedFromServer", false);
    //     this.$store.dispatch("loadCalendarList", reqData);
    //   } else if (query.rangeUnit === "week") {
    //     const reqData = {
    //       userId: this.$store.state.userState.userId,
    //       searchQueryFilterAfter: new Date(query.range.start).getTime() - 2 * millisecondsInDay,
    //       searchQueryFilterBefore: new Date(query.range.end).getTime() + 2 * millisecondsInDay
    //     };
    //     console.log("reqdata", reqData);
    //     this.$store.commit("calendarEventsLoadedFromServer", false);
    //     this.$store.dispatch("loadCalendarList", reqData);
    //   } else if (query.rangeUnit === "day") {
    //     const reqData = {
    //       userId: this.$store.state.userState.userId,
    //       searchQueryFilterAfter: new Date(query.range.start).getTime() - millisecondsInDay,
    //       searchQueryFilterBefore: new Date(query.range.end).getTime() + millisecondsInDay
    //     };
    //     console.log("reqdata", reqData);
    //     this.$store.commit("calendarEventsLoadedFromServer", false);
    //     this.$store.dispatch("loadCalendarList", reqData);
    //   }
    // },
    // async fetchDataWeekMonth(query) {
    //   const millisecondsInDay = 24 * 60 * 60 * 1000;
    //   if (query.buttonPressed === "week") {
    //     const reqData = {
    //       userId: this.$store.state.userState.userId,
    //       searchQueryFilterAfter: new Date(query.range.start).getTime() - 2 * millisecondsInDay,
    //       searchQueryFilterBefore: new Date(query.range.end).getTime() + 2 * millisecondsInDay
    //     };
    //     console.log(reqData);
    //     console.log("created mycalendar.vue")
    //     this.$store.commit("calendarEventsLoadedFromServer", false);
    //     this.$store.dispatch("loadCalendarList", reqData);
    //   } else {
    //     const reqData = {
    //       userId: this.$store.state.userState.userId,
    //       searchQueryFilterAfter: new Date(query.range.start).getTime(),
    //       searchQueryFilterBefore: new Date(query.range.end).getTime()
    //     };
    //     console.log(reqData);
    //     console.log("created mycalendar.vue")
    //     this.$store.commit("calendarEventsLoadedFromServer", false);
    //     this.$store.dispatch("loadCalendarList", reqData);
    //   }
    // },
    async getData(query) {
      const reqData = {
        userId: this.$store.state.userState.userId,
        searchQueryFilterAfter: query.start * 1000,
        searchQueryFilterBefore: query.end * 1000
      }
      console.log(reqData);
      this.$store.commit("calendarEventsLoadedFromServer", false);
      this.$store.dispatch("loadCalendarList", reqData);
    },
    async handlePrevNextClick(info) {
      if (info.ButtonType === "Prev") {
        this.$refs.calendarRef.calendar.prev();
        recordAnalyticsEvent(AnalyticsEvents.v2CalendarPrevPressed, { viewType: this.$refs.calendarRef.calendar.currentData.dateProfile.currentRangeUnit });
        let uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.start).toString();
        if (!this.isNotMoreThanSevenMonthsBack(uniqueMonth)) {
          console.log("data requested for more that Seven months before");
          this.$refs.calendarRef.calendar.next();
          return;
        }
        console.log("first in prev", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.decrementUniqueMonth(uniqueMonth);
        console.log("second in prev", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
        console.log("third in prev", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }

      } else if (info.ButtonType === "Next") {
        this.$refs.calendarRef.calendar.next();
        recordAnalyticsEvent(AnalyticsEvents.v2CalendarNextPressed, { viewType: this.$refs.calendarRef.calendar.currentData.dateProfile.currentRangeUnit });
        let uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.start).toString();
        if (!this.isNotMoreThanThreeMonthsAhead(uniqueMonth)) {
          console.log("data requested for more that three months");
          this.$refs.calendarRef.calendar.prev();
          return;
        }
        console.log("first in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
        console.log("second in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
      }
    },
    async handleViewClick(info) {
      if (info.ButtonType === "month") {
        recordAnalyticsEvent(AnalyticsEvents.v2CalendarMonthViewShow);
        this.$refs.calendarRef.calendar.changeView('dayGridMonth');
        let uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.start).toString();
        console.log("first in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
        console.log("second in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        // const query = {
        //   rangeUnit: this.$refs.calendarRef.calendar.currentData.dateProfile.currentRangeUnit,
        //   range: this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange,
        //   buttonpressed: "month"
        // }
        // //console.log("query", query)
        // await this.fetchDataWeekMonth(query);
      } else if (info.ButtonType === "week") {
        recordAnalyticsEvent(AnalyticsEvents.v2CalendarWeekViewShow);
        this.$refs.calendarRef.calendar.changeView('timeGridWeek');
        let uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.start).toString();
        console.log("first in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
        console.log("second in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        // const query = {
        //   rangeUnit: this.$refs.calendarRef.calendar.currentData.dateProfile.currentRangeUnit,
        //   range: this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange,
        //   buttonPressed: "week"
        // }
        // //console.log("query", query)
        // await this.fetchDataWeekMonth(query);
      } else if (info.ButtonType === "day") {
        recordAnalyticsEvent(AnalyticsEvents.v2CalendardayViewShow);
        this.$refs.calendarRef.calendar.changeView('timeGridDay');
        let uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.start).toString();
        console.log("first in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
        console.log("second in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
      } else if (info.ButtonType === "list") {
        recordAnalyticsEvent(AnalyticsEvents.v2CalendarlistViewShow);
        this.$refs.calendarRef.calendar.changeView('listDay');
        let uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.start).toString();
        console.log("first in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
        uniqueMonth = this.getUniqueMonth(this.$refs.calendarRef.calendar.currentData.dateProfile.currentRange.end).toString();
        console.log("second in next", uniqueMonth);
        if (!monthDataFetched.value.has(uniqueMonth)) {
          const query = this.getStartAndEndUnixTimestamps(uniqueMonth);
          monthDataFetched.value.add(uniqueMonth);
          await this.getData(query);
        }
      }
    },
    isNotMoreThanSevenMonthsBack(inputDate) {
      try {
        // Parse the input date into year and month components
        const [year, month] = inputDate.split("-").map(Number);

        // Get the current date
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1 to get the actual month

        // Calculate the difference in months
        const monthsDifference = (currentYear - year) * 12 + (currentMonth - month);

        // Check if the input date is not more than 7 months before the current month and year
        return monthsDifference <= 7;
      } catch (error) {
        return true; // Return true on error (e.g., if the input date format is incorrect)
      }
    },
    isNotMoreThanThreeMonthsAhead(inputDate) {
      try {
        // Parse the input date into year and month components
        const [year, month] = inputDate.split("-").map(Number);

        // Get the current date
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1 to get the actual month

        // Calculate the difference in months
        const monthsDifference = (year - currentYear) * 12 + (month - currentMonth);

        // Check if the input date is not more than 3 months ahead of the current month and year
        return monthsDifference <= 3;
      } catch (error) {
        return true; // Return true on error (e.g., if the input date format is incorrect)
      }
    },
    getUniqueMonth(dateStr) {
      try {
        // Parse the date string into a Date object
        const dateObj = new Date(dateStr);

        // Extract the month and year from the Date object
        const month = dateObj.getMonth() + 1; // Months are zero-indexed, so add 1 to get the actual month
        const year = dateObj.getFullYear();

        // Create a unique representation of the month
        const uniqueMonth = `${year}-${month.toString().padStart(2, '0')}`;
        return uniqueMonth;
      } catch (error) {
        return null;
      }
    },
    getStartAndEndUnixTimestamps(uniqueMonth) {
      try {
        // Parse the unique month string into year and month components
        const [year, month] = uniqueMonth.split("-").map(Number);

        // Create the start of the month Date object
        const startDate = new Date(year, month - 1, 1); // Months are zero-indexed, so subtract 1 to get the correct month

        // Create the end of the month Date object
        const endDate = new Date(year, month, 0, 23, 59, 59, 999); // Set the last day of the month and time to 23:59:59.999

        // Convert the Date objects to Unix timestamps
        const startUnixTimestamp = Math.floor(startDate.getTime() / 1000);
        const endUnixTimestamp = Math.floor(endDate.getTime() / 1000);

        return {
          start: startUnixTimestamp,
          end: endUnixTimestamp,
        };
      } catch (error) {
        return null;
      }
    },
    decrementUniqueMonth(uniqueMonth) {
      let [year, month] = uniqueMonth.split("-").map(Number);
      month--;
      const UniMon = `${year}-${month.toString().padStart(2, '0')}`;
      return UniMon;
    },
    getEventColorNonFullDay(startTime, endTime) {
      const currentTime = Date.now();
      if (endTime === null)
        return "#cae5f9";
      //console.log("c1t:", currentTime)
      if (currentTime < startTime) {
        // Event is upcoming
        return '#fbddbc';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        // Event is ongoing
        return '#cae5f9';
      } else {
        // Event is in the past
        return '#e3e3e2';
      }
    },
    getEventColorFullDay(date) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

      const dateParts = date.split('-');

      const eventYear = parseInt(dateParts[0], 10);
      const eventMonth = parseInt(dateParts[1], 10) - 1; // Months are zero-based
      const eventDay = parseInt(dateParts[2], 10);

      const eventDate = new Date(eventYear, eventMonth, eventDay);
      //console.log(date, currentDate, eventDate)
      if (currentDate < eventDate) {
        // Event is upcoming
        return '#fbddbc';
      } else if (currentDate.getTime() === eventDate.getTime()) {
        // Event is ongoing
        return '#cae5f9';
      } else {
        // Event is in the past
        return '#e3e3e2';
      }
    },
    getStartEndOfCurrentMonth(year, month) {
      var now = new Date();
      if (!year || year === undefined) {
        year = now.getFullYear();
      }
      if (!month || month === undefined) {
        month = now.getMonth();
      }
      var startOfMonth = new Date(year, month, 1);
      var nextMonth = new Date(year, month + 1, 1);
      var endOfMonth = new Date(nextMonth.getTime() - 1);
      var startTimestamp = startOfMonth.getTime();
      var endTimestamp = endOfMonth.getTime(); // Adding milliseconds to reach the end of the day

      return [startTimestamp, endTimestamp];
    },
    injectTimmingsInListViewForWholeDayEvent() {
      for (let x = 0; x < this.$refs.calendarRef.calendar.el.getElementsByClassName("fc-list-event-time").length; x++) {
                if (this.$refs.calendarRef.calendar.el.getElementsByClassName("fc-list-event-time") && this.$refs.calendarRef.calendar.el.getElementsByClassName("fc-list-event-time")[x].innerHTML.trim() === '') {
                  this.$refs.calendarRef.calendar.el.getElementsByClassName("fc-list-event-time")[x].innerHTML = "<div>12:00am - 12:00am</div>";
                  console.log("Hello");
                }
              }
    },
    getClassType(type) {
      if (type === "Online") {
        return "LiveClass"
      } else if (type === "Offline") {
        return "OfflineClass"
      } else if (type === "Other") {
        return "OtherClass"
      } else {
        return "";
      }
    },
    converttime(item) {
      // var enddate = args.event.end
      console.log(item)
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var news = item.toLocaleDateString(undefined, options)
      return news;
    },
    viewTestSyllabus(item) {
      // console.log(item)
      // recordAnalyticsEvent(AnalyticsEvents.v2TestListTestDetailOpen);
      this.currentTest = item
      this.syllabusDialog = true
    },
    showDialog() {
      this.show = true;
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    getDateTimeFromTimeStamp(timestamp) {
      if (timestamp === 0) {
        return "---";
      }
      let date = new Date(timestamp);
      var dateString = moment(date).format("D MMM  YYYY	hh:mm A	");
      return dateString
    },
    getUserInvite(item) {
      //console.log(item);
      recordAnalyticsEvent(AnalyticsEvents.v2CalendarOnlineClassOpen, { meetingId: item.zoomid });
      this.$store.commit("classesListLoadedFromServer", false);
      this.$store.dispatch('getUserInvite', {
        'meetingId': item.zoomid,
        'meetingType': item.meetingType,
        'zoomAccount': item.zoomAccount,
      }).then((zoomMeetingInvite) => {
        if (zoomMeetingInvite) {
          const url = zoomMeetingInvite.join_url;
          window.open(url);
        }
        this.$store.commit("classesListLoadedFromServer", true);
      })
    },
    openTest(item) {
      recordAnalyticsEvent(AnalyticsEvents.v2CalendarTestOpen, { TestId: item.extendedProps.testId });
      //console.log("awdawdawd", item.extendedProps)
      this.$router.replace(`/testseries/${item.extendedProps.collectionIds[0]}/0`);
    },
    getButtonColor(date) {
      const currentDate = new Date();
      const inputTime = new Date(date);
      //console.log(date)
      if (inputTime < currentDate) {
        return "black"; // Date has passed (in the past)
      } else {
        return "primary"; // Date is ongoing or in the future
      }
    },
    isButtonDisabled(date) {
      const currentDate = new Date();
      const inputTime = new Date(date);
      if (inputTime < currentDate) {
        return true; // Date has passed (in the past)
      } else {
        return false; // Date is ongoing or in the future
      }
    }
  },
}
</script>

<template>
  <v-dialog class="dialog-bx scroll" style="z-index: 999999;" v-model="syllabusDialog" max-width="600px" max-height="850px">
    <v-card v-if="currentTest.extendedProps.activitytype == 'Test'" class="my-1 pa-5">
      <v-card-item>
        <v-card-title class="t-h6">
          <v-row class="align-center ma-0 pa-0 heading-block">
            {{ this.currentTest.extendedProps.testName }}
          </v-row>
        </v-card-title>
      </v-card-item>
      <v-card-text class="t-subtitle">
        <v-row class="align-center subjects-test-disp">
          <v-col cols="12" v-if="this.currentTest.extendedProps.subjects != null">
            {{ this.currentTest.extendedProps.subjects.toString() }}
          </v-col>
        </v-row>
        <v-row class="align-center date-block pa-2" justify="start">
          <v-col cols="12" lg="3" offset="0">
            <v-row  class="timimg-text-cls t-subtitle" justify="start">
                <v-icon>mdi-clock-outline</v-icon>
                <div>
                  <strong>
                    {{ this.currentTest.extendedProps.testDurationInMinutes }} mins
                  </strong>
                </div>
            </v-row>
          </v-col>
          <v-col class="t-subtitle" cols="12" lg="6" offset="0">
            <v-row class="pa-1">
              <strong>Starting</strong>: {{ getDateTimeFromTimeStamp(this.currentTest.extendedProps.startTest) }}
            </v-row>
            <v-row class="pa-1">
              <strong>Ending</strong>: {{ getDateTimeFromTimeStamp(this.currentTest.extendedProps.endTest) }}
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col> -->
          <!-- <v-row justify="start" justify-lg="end"> -->
          <v-btn class="my-3 mr-2 btn-test-join" color="primary" @click="openTest(this.currentTest)" elevation="0">View Test</v-btn>
          <v-btn class="mr-2 text-capitalize my-3" variant="tonal" elevation="0"
            @click="syllabusDialog = false">Close</v-btn>
          <!-- </v-row> -->
          <!-- </v-col> -->
        </v-row>

      </v-card-text>
    </v-card>

    <v-card v-else elevation="0" class="my-1 pa-5">
      <v-container class="ma-0">
        <v-card-text>
          <v-row class="ma-0 pa-0" justify="center" style="text-align:justify">
            <v-col cols="1">
              <v-avatar rounded="0" size="small">
                <v-img v-if="this.currentTest.extendedProps.activitytype === 'LiveClass'" height="32"
                  src="assets/images/live_v2.svg"></v-img>
                <v-img v-if="this.currentTest.extendedProps.activitytype === 'OfflineClass'" height="32"
                  src="assets/images/class_v2.svg"></v-img>
                <v-img v-if="this.currentTest.extendedProps.activitytype === 'OtherClass'" height="32"
                  src="assets/images/class_v2.svg"></v-img>
              </v-avatar>
            </v-col>
            <v-col cols="11">
              <v-row align="center">
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12">
                      <span class="heading-block">
                        {{ this.currentTest.title }}
                      </span>
                    </v-col>
                    <v-col v-if="this.currentTest.extendedProps.id == 'activities'" cols="12">
                      <span class="date-block">
                        {{ this.currentTest.extendedProps.meeting_detailsS }}
                      </span>
                      <span class="mx-2">-</span>
                      <span class="date-block">
                        {{ this.currentTest.extendedProps.meeting_detailsE }}
                      </span>
                    </v-col>
                    <v-col v-if="this.currentTest.extendedProps.id == 'recurringActivities'" cols="12">
                      <span class="date-block">
                        <span class="date-block">
                          {{ this.currentTest.extendedProps.meeting_detailsS }}
                        </span>
                        <span class="mx-4">-</span>
                        <span class="date-block">
                          {{ this.currentTest.extendedProps.meeting_detailsE }}
                        </span>
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <span style="display:block;" class="description-block">
                        {{ currentTest.extendedProps.description }}
                        <div class="btn-class-joins">
                          <v-btn class="mr-2 text-capitalize my-3"
                            :color="this.getButtonColor(currentTest.extendedProps.meeting_detailsE)"
                            :disabled="this.isButtonDisabled(currentTest.extendedProps.meeting_detailsE)"
                            :variant="this.isButtonDisabled(currentTest.extendedProps.meeting_detailsE) ? 'tonal' : ''"
                            v-if="currentTest.extendedProps.activitytype === 'LiveClass'" elevation="0"
                            @click="getUserInvite(currentTest.extendedProps)">Join Class</v-btn>
                          <v-btn class="my-3" variant="tonal" elevation="0" @click="syllabusDialog = false">Close</v-btn>
                        </div>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>

              </v-row>
            </v-col>
          </v-row>

        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>

  <!-- <AppBar :show="true"></AppBar>
  <NavigationDrawer :show="true"></NavigationDrawer> -->

  <v-container class="bg-background ma-0 pa-4">
    <v-row class="ma-0 pa-0 spacing" align="center">
      <v-col class="ma-0 pa-0">
        <v-icon icon="mdi-calendar" color="primary" class="mr-2"></v-icon>
        <span>My Calendar</span>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div class="color-coding">
      <div class="color-coding-event">
        <div class="past-color"></div>
        <div>Past</div>
      </div>
      <div class="color-coding-event">
        <div class="ongoing-color"></div>
        <div>Ongoing</div>
      </div>
      <div class="color-coding-event">
        <div class="upcoming-color"></div>
        <div>Upcoming</div>
      </div>
    </div>
    <v-container class="mt-4 ma-0 pa-0">
      <FullCalendar ref="calendarRef" id='calendar' :options='calendarOptions' @eventRender="showPopup" />
      <div v-for="(item, index) in calendarEvents" :key="index">
        <!-- <span>{{item}}</span> -->
      </div>
    </v-container>
    <v-divider></v-divider>
  </v-container>
</template> 

<style scoped>
.v-container {
  max-width: 100%;
}

@media (max-width: 1920px) {
  #calendar {
    max-width: 80vw;
    margin: auto;
  }
}

@media (max-width: 1530px) {
  #calendar {
    max-width: 75vw;
    margin: auto;
  }
}

@media (max-width: 1280px) {
  #calendar {
    max-width: 70vw;
    margin: auto;
  }
}

@media (max-width: 960px) {
  #calendar {
    max-width: 100vw;
    margin: auto;
  }
}

.v-card {
  border: 1px solid rgb(var(--v-theme-secondary));
}

.v-card.on-hover {
  cursor: pointer;
  border: 1px solid rgb(var(--v-theme-primary));
  background-color: #fff;
}

.heading-block {
  font-weight: 600;
  font-size: 16px;
  line-height: 17px;
  color: #282828;
}

.date-block {
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #888888;
}

.description-block {
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  font-style: italic;
  color: #515151;
  height: 45px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.timimg-text-cls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-left: -10px;
}

.btn-test-join {
  text-decoration: none;
  margin-left: 12px;
}

.subjects-test-disp {
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #888888;
  margin-top: -2px;
}

.btn-test-join:hover {
  text-decoration: none;
}

.btn-class-joins {
  font-style: normal;
}

.fc-event-title {
  text-overflow: ellipsis;
}

.scroll {
  overflow-y: scroll;
}

.color-coding {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.color-coding-event {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.past-color {
  height: 17px;
  width: 17px;
  background-color: #e3e3e2;
  border-radius: 4px;
}

.ongoing-color {
  height: 17px;
  width: 17px;
  background-color: #cae5f9;
  border-radius: 4px;
}

.upcoming-color {
  height: 17px;
  width: 17px;
  background-color: #fbddbc;
  border-radius: 4px;
}
</style>


<!-- <style>
.fc-event-title {
  text-overflow: ellipsis;
}

.fc-header {
  display: flex;
}

.fc-toolbar-chunk {
  margin: 5px;
}

.fc-toolbar {
  flex-wrap: wrap;
}

.fc-header-right {
  width: 25%;
  text-align: right;
}

.fc-button {
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.scroll {
  overflow-y: scroll;
}

body::-webkit-scrollbar {
  display: none;
}
</styl> -->


<style>
.spacing {
  padding: 15px 5px !important;
}
.fc-event-time{
  overflow: visible !important;
  text-transform: uppercase !important;
}

.fc-prev-button>span {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.fc-next-button>span {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.tooltip-calendar-container {
  padding: 10px;
}

.tooltip-calendar-top {
  color: #191919;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  font-weight: 700;
}

.tooltip-calendar-bottom {
  margin-top: 10px;
  font-weight: 700;
}

.tooltip-calendar-timming {
  margin-left: 10px;
  font-size: 14px !important;
  font-weight: normal !important;
  margin-bottom: 5px;
}
</style>